'use client'

import * as React from 'react'
import Image from 'next/image'
import { Crown, Star, Trophy } from 'lucide-react'
import { DEFAULT_APPEARANCE, type BracketAppearance } from './appearance'

export const AppearanceContext =
  React.createContext<BracketAppearance>(DEFAULT_APPEARANCE)

export function ChampionIcon({
  size,
  className,
}: {
  size?: number
  className?: string
}) {
  const appearance = React.useContext(AppearanceContext)
  if (appearance.icon === 'none') return null
  const dimension = size ?? appearance.iconSize
  if (appearance.icon === 'custom' && appearance.customIcon) {
    return (
      <Image
        unoptimized
        src={appearance.customIcon}
        alt=""
        aria-hidden
        width={dimension}
        height={dimension}
        className={className}
        style={{ width: dimension, height: dimension, objectFit: 'contain' }}
      />
    )
  }
  const Icon =
    appearance.icon === 'star'
      ? Star
      : appearance.icon === 'trophy'
        ? Trophy
        : Crown
  return (
    <Icon
      aria-hidden
      className={className}
      width={dimension}
      height={dimension}
      style={{ color: appearance.iconColor, flexShrink: 0 }}
      strokeWidth={2}
    />
  )
}
